/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemRateEntryInputDto } from './OemRateEntryInputDto';
import {
    OemRateEntryInputDtoFromJSON,
    OemRateEntryInputDtoFromJSONTyped,
    OemRateEntryInputDtoToJSON,
    OemRateEntryInputDtoToJSONTyped,
} from './OemRateEntryInputDto';

/**
 * 
 * @export
 * @interface UpdateOemContractRequestDto
 */
export interface UpdateOemContractRequestDto {
    /**
     * 
     * @type {Date}
     * @memberof UpdateOemContractRequestDto
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateOemContractRequestDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOemContractRequestDto
     */
    status?: UpdateOemContractRequestDtoStatusEnum;
    /**
     * 
     * @type {Array<OemRateEntryInputDto>}
     * @memberof UpdateOemContractRequestDto
     */
    rateEntries?: Array<OemRateEntryInputDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOemContractRequestDto
     */
    notes?: string;
}


/**
 * @export
 */
export const UpdateOemContractRequestDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type UpdateOemContractRequestDtoStatusEnum = typeof UpdateOemContractRequestDtoStatusEnum[keyof typeof UpdateOemContractRequestDtoStatusEnum];


/**
 * Check if a given object implements the UpdateOemContractRequestDto interface.
 */
export function instanceOfUpdateOemContractRequestDto(value: object): value is UpdateOemContractRequestDto {
    return true;
}

export function UpdateOemContractRequestDtoFromJSON(json: any): UpdateOemContractRequestDto {
    return UpdateOemContractRequestDtoFromJSONTyped(json, false);
}

export function UpdateOemContractRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOemContractRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'status': json['status'] == null ? undefined : json['status'],
        'rateEntries': json['rateEntries'] == null ? undefined : ((json['rateEntries'] as Array<any>).map(OemRateEntryInputDtoFromJSON)),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateOemContractRequestDtoToJSON(json: any): UpdateOemContractRequestDto {
    return UpdateOemContractRequestDtoToJSONTyped(json, false);
}

export function UpdateOemContractRequestDtoToJSONTyped(value?: UpdateOemContractRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'status': value['status'],
        'rateEntries': value['rateEntries'] == null ? undefined : ((value['rateEntries'] as Array<any>).map(OemRateEntryInputDtoToJSON)),
        'notes': value['notes'],
    };
}

